'use client';

import type {FC} from 'react';
import {useLiveQuery} from 'next-sanity/preview';
import {internalLinkToHref} from 'utils';
import type {LinkReferencesQueryResult} from 'utils/sanity.queries';
import {LINK_REFERENCES_QUERY} from 'utils/sanity.queries';

import type {FeaturedLinkSchema} from 'components/content-blocks/featured-links/schema';

import {FeaturedLinkRender} from './render';

interface Props {
	featuredLink: FeaturedLinkSchema;
}

export const FeaturedLinkDraft: FC<Props> = ({featuredLink}) => {
	const [reference, loading] = useLiveQuery<LinkReferencesQueryResult>(
		null,
		LINK_REFERENCES_QUERY,
		{
			id: featuredLink.link?.reference?._ref ?? '',
		},
	);

	if (loading) {
		return <FeaturedLinkRender href="#" text="Loading..." title="Loading..." />;
	}

	return (
		<FeaturedLinkRender
			href={internalLinkToHref(reference?._type, reference?.slug?.current)}
			targetBlank={featuredLink.link?.targetBlank}
			text={featuredLink.text}
			title={featuredLink.title}
			tagline={featuredLink.tagline}
			theme={featuredLink.theme}
		/>
	);
};
